module.exports = __webpack_public_path__ + "7ba22a509aaf16c74680ea2e7b1af519.fbx";